import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { StyledPopover, StyledInputArea, StyledInputField, StyledDeleteArea, StyledLine, StyledPickColorArea, StyledPickColorAreaTitle, StyledPalette, StyledSingleColor } from './EditTagOptionPopover.styles.js';
import Grid from '../Grid/Grid.js';
import { TAG_COLORS } from '../constants/common.js';

/* eslint-disable react/prop-types */
function EditTagOptionPopover(_ref) {
  let {
    popoverId,
    open,
    anchorEl,
    onClose,
    onEditOptionItem,
    onDeleteItem,
    selectedTag,
    onPickOptionColor
  } = _ref;
  const [itemValue, setItemValue] = useState('');
  useEffect(() => {
    if (open) {
      setItemValue(selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.label);
    } else {
      setItemValue('');
    }
  }, [open]);
  const handleChange = e => {
    setItemValue(e.target.value);
  };
  const handleKeyDownEnter = value => {
    onEditOptionItem({
      value,
      target: selectedTag
    });
  };
  const handleDelete = () => {
    onDeleteItem({
      target: selectedTag
    });
  };
  const handleChooseColor = color => {
    onPickOptionColor({
      value: color,
      target: selectedTag
    });
  };
  return /*#__PURE__*/React__default.createElement(StyledPopover, {
    id: popoverId,
    onClick: e => e.stopPropagation(),
    open: open,
    anchorEl: anchorEl,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  }, /*#__PURE__*/React__default.createElement(StyledInputArea, null, /*#__PURE__*/React__default.createElement(StyledInputField, {
    onClick: e => e.stopPropagation(),
    value: itemValue,
    onChange: handleChange,
    onEnter: handleKeyDownEnter
  })), /*#__PURE__*/React__default.createElement(StyledDeleteArea, {
    onClick: handleDelete
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_trash font-size-16"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "delete-text"
  }, "Delete")), onPickOptionColor && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledLine, null), /*#__PURE__*/React__default.createElement(StyledPickColorArea, null, /*#__PURE__*/React__default.createElement(StyledPickColorAreaTitle, null, "Colors"), /*#__PURE__*/React__default.createElement(StyledPalette, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 0.5
  }, TAG_COLORS.map((color, i) => /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default.createElement(Grid, {
    item: true,
    xs: 4,
    display: "flex",
    justifyContent: "center",
    key: i
  }, /*#__PURE__*/React__default.createElement(StyledSingleColor, {
    onClick: () => handleChooseColor(color),
    color: color
  }))))))));
}
EditTagOptionPopover.propTypes = {
  popoverId: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Element)]),
  onClose: PropTypes.func,
  onEditOptionItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  selectedTag: PropTypes.shape({
    option: PropTypes.shape({
      label: PropTypes.string
    })
  }),
  onPickOptionColor: PropTypes.func
};
EditTagOptionPopover.defaultProps = {
  popoverId: '',
  open: false,
  anchorEl: null,
  onClose: () => {},
  onEditOptionItem: () => {},
  onDeleteItem: () => {},
  selectedTag: {
    option: {
      label: ''
    }
  },
  onPickOptionColor: () => {}
};
export { EditTagOptionPopover as default };